import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledStepTarget = styled(Box)<{ portrait: number }>`
	background: #ffffff;
	border: 0.1383em solid rgba(0, 0, 0, 0.3);
	box-shadow: 0 0.2772em 0.2772em rgba(0, 0, 0, 0.25);
	border-radius: 1.375em;
	font-size: 1.28em;
	display: flex;
	align-items: center;
	padding: 0.172em 0.686em 0.172em 0.343em;
	font-weight: bold;
	color: #333333;
	width: ${(props) => (props.portrait ? "3.75em" : "auto")};
	display: flex;
	justify-content: flex-end;

	&.claimed {
		background: rgba(255, 255, 255, 0.3);
	}

	svg {
		height: 1em;
	}

	&.mega-menu-variant {
		padding: 0.172em 0.586em 0.172em 0.586em;

		svg {
			width: auto;
			margin-right: 0.3em;
		}
	}
`;
